/**
 * Centralized API functions for Front Menu Setting functionality
 */
import { getData, putData } from "../apiClient";

// get all front menu items
export const getFrontMenuItems = async ({
  page = 1,
  limit = 10,
  search = "",
}) => {
  try {
    const queryParams = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      search: search,
    });

    const result = await getData(`/front-menu-list/get?${queryParams}`);
    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error("Get front menu items API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
        data: [],
        totalPages: 1,
        prevPage: false,
        nextPage: false,
        totalDocs: 0,
        page: 1,
      },
    };
  }
};

export const getFrontMenuItemDataWithId = async (id) => {
  try {
    const result = await getData(`/front-menu-list/getbyid/${id}`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error("Get user data API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

export const GetParentMenu = async () => {
  try {
    const result = await getData(`/front-menu-list/getparentmenu`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error("Get Parent Menu data API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

export const updateFrontMenuItem = async ({ id, data }) => {
  try {
    const result = await putData(`/front-menu-list/update/${id}`, data);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error("Update Menu Setting API error:", error);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};
